import { TabData } from 'src/components/molecules/Tabs/Tabs'

import {
  viewPlantingPath,
  viewPlantingMonitoringPath,
  viewPlantingPhotosPath
} from 'src/config/paths'
import { PlantingType } from 'src/types/planting'

export enum PlantingNavTab {
  Details = 'details',
  Monitorings = 'monitorings',
  Photos = 'photos'
}
export function getTabs(planting: PlantingType): TabData[] {
  return [
    {
      label: 'Planting details',
      value: PlantingNavTab.Details,
      path: viewPlantingPath({
        routeParams: {
          applicationId: planting.ApplicationId,
          plantingId: planting.Id,
          projectId: planting.Application?.Project?.Id
        }
      })
    },
    {
      label: 'Monitorings',
      value: PlantingNavTab.Monitorings,
      path: viewPlantingMonitoringPath({
        routeParams: {
          applicationId: planting.ApplicationId,
          plantingId: planting.Id,
          projectId: planting.Application?.Project?.Id
        }
      })
    },
    {
      label: 'Photos',
      value: PlantingNavTab.Photos,
      path: viewPlantingPhotosPath({
        routeParams: {
          applicationId: planting.ApplicationId,
          plantingId: planting.Id,
          projectId: planting.Application?.Project?.Id
        }
      })
    }
  ]
}
